import React, { useState } from "react";

import "./component.css";

const initialFoodItems = [
  {
    title: "Sambar Dosa",
    price: "2.5 ₹",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
  {
    title: "Idli Vada",
    price: "1.5 ₹",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
  {
    title: "Paneer Roll",
    price: "3.0 ₹",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
];

export default function FoodGridMobileOnly() {
  const [foodItems, setFoodItems] = useState(initialFoodItems);

  const increaseQuantity = (index) => {
    const updatedItems = [...foodItems];
    updatedItems[index].quantity += 1;
    setFoodItems(updatedItems);
  };

  const decreaseQuantity = (index) => {
    const updatedItems = [...foodItems];
    if (updatedItems[index].quantity > 1) {
      updatedItems[index].quantity -= 1;
      setFoodItems(updatedItems);
    }
  };

  return (
    <div style={{ padding: "0 5px", backgroundColor: "#F4F5F7" }}>
      <div id="myappcrd" className="container py-3 d-block d-md-none">
        <div className="card-box  rounded  p-3">
          {foodItems.map((item, idx) => (
            <div key={idx} className="d-flex align-items-start mb-3">
              <img
                src={item.img}
                alt={item.title}
                className="food-image rounded img-fluid me-2"
                style={{ width: "90px", height: "90px", objectFit: "cover" }}
              />
              <div className="flex-grow-1">
                <h6 className="mb-1 fw-semibold">{item.title}</h6>
                <div className="text-muted small">{item.plate}</div>
                <div className="text-muted small">{item.waiting}</div>
                <div className="text-muted small">{item.price}</div>
              </div>
              <div className="quantity-box ms-2 bg-dark text-white rounded d-flex align-items-center px-2">
                <button
                  className="btn btn-sm text-white px-1 py-0"
                  onClick={() => decreaseQuantity(idx)}
                >
                  −
                </button>
                <span className="mx-1 fw-semibold">{item.quantity}</span>
                <button
                  className="btn btn-sm text-white px-1 py-0"
                  onClick={() => increaseQuantity(idx)}
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
